import { http } from "../../lib/http";

/* ------------------------------- RESEÑAS ------------------------------ */
export const reviews = {
  /** `scope`: business | domiciliary | user */
  list: (params) => http.get("/admin/reviews", { params }).then((r) => r.data),
  remove: (scope, id) =>
    http
      .delete("/admin/reviews", { data: { scope, reviews_id: id } })
      .then((r) => r.data),

  /** Moderar es un trabajo por tandas: de a una son cuatro clics por reseña. */
  removeLote: (scope, ids) =>
    http
      .delete("/admin/reviews/lote", { data: { scope, ids } })
      .then((r) => r.data),
};


export const pqrs = {
  list: (params) => http.get("/admin/pqrs", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/pqrs/${id}`).then((r) => r.data),
  create: (body) => http.post("/admin/pqrs", body).then((r) => r.data),
  update: (id, body) => http.put(`/admin/pqrs/${id}`, body).then((r) => r.data),
  addNote: (id, body) =>
    http.post(`/admin/pqrs/${id}/notes`, body).then((r) => r.data),
};


/* --------------------- SST · CALIDAD · CONTABILIDAD -------------------- */
/**
 * Los tres módulos que le faltaban al panel para que esas áreas trabajaran.
 * Comparten controlador en el backend pero no permisos: cada bloque va detrás
 * de su propio módulo.
 *
 * Los listados devuelven `{ data, summary }`: los contadores son del TOTAL y no
 * de lo filtrado, para que el número de documentos vencidos no cambie porque
 * alguien buscó un nombre.
 */
export const sst = {
  documentos: {
    list: (params) =>
      http.get("/admin/sst/documentos", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/sst/documentos", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/sst/documentos/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/sst/documentos/${id}`).then((r) => r.data),
  },

  incidentes: {
    list: (params) =>
      http.get("/admin/sst/incidentes", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/sst/incidentes", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/sst/incidentes/${id}`, body).then((r) => r.data),
  },
};


/* ------------------------------ AUDITORÍA ----------------------------- */
export const audits = {
  list: (params) => http.get("/admin/audits", { params }).then((r) => r.data),
};

/* --------------------------- FALLOS DE LA APP -------------------------- */
/*
 * Lo que se rompio en el telefono de alguien. Lo manda el `ErrorBoundary` de
 * la app a `POST /v1/app/errores`; aqui se lee.
 *
 * Dos formas de mirarlo, y la que importa es la segunda: `list` da los fallos
 * uno por uno, y `resumen` los agrupa por mensaje y pantalla. El mismo fallo en
 * cien telefonos es UN problema, no cien.
 */
export const fallos = {
  list: (params) => http.get("/admin/fallos", { params }).then((r) => r.data),
  resumen: (params) =>
    http.get("/admin/fallos/resumen", { params }).then((r) => r.data),
};
